import { useContext } from 'react';
import { CollabInviteContext, CollabInviteContextType } from '../contexts/collab_invite_context';

const useCollabInvite = () => {
    return useContext(CollabInviteContext) as CollabInviteContextType;
};

export default useCollabInvite;
